<form class="form" [formGroup]="settingsForm">
  <p class="font-bold text-lg timefence-data-heading">
    {{ "modules.notification.alarmRuleAddEdit.timefenceDescription" | translate }}
  </p>
  <div class="form__timefence-week-container">
    <osp-timefence-week [formControlName]="controlNames.SETTINGS_STEP2_TIMEFENCING_WEEK_DAY" />
    <osp-error
      class="form__timefence-week-container-errors"
      [errors]="$timefenceWeekErrors()"
      [messages]="{
        weekDayRequired: 'shared.validation.requiredField' | translate
      }"
    />
  </div>
</form>
